(function() {
  if (window.productFeaturesInitialized) {
    return;
  }

  window.productFeaturesInitialized = true;
  var instances = new Map();

  function pauseInactiveVideos(container, selectedIndex) {
    container.querySelectorAll('[data-feature-slide]').forEach(function(slide, index) {
      if (index === selectedIndex) {
        return;
      }

      slide.querySelectorAll('video').forEach(function(video) {
        video.pause();
      });
    });
  }

  function updateArrowPosition(carousel) {
    var media = carousel.querySelector('.product-features__media');

    if (media) {
      carousel.style.setProperty('--features-arrow-top', media.offsetTop + media.offsetHeight / 2 + 'px');
    }
  }

  function pauseLightboxVideos() {
    document.querySelectorAll('.product-features-lightbox__video').forEach(function(video) {
      video.pause();
    });
  }

  function createLightboxItems(carousel) {
    return Array.from(carousel.querySelectorAll('[data-feature-lightbox-trigger]')).map(function(trigger) {
      if (trigger.dataset.featureMediaType === 'video') {
        var wrapper = document.createElement('div');
        var video = document.createElement('video');

        wrapper.className = 'product-features-lightbox__video-wrap';
        video.className = 'product-features-lightbox__video';
        video.controls = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.poster = trigger.dataset.featureMediaPoster;
        video.src = trigger.dataset.featureMediaSrc;
        wrapper.appendChild(video);

        return {html: wrapper};
      }

      return {
        el: trigger.querySelector('img'),
        h: parseInt(trigger.dataset.featureMediaHeight, 10),
        msrc: trigger.querySelector('img').currentSrc || trigger.querySelector('img').src,
        src: trigger.dataset.featureMediaSrc,
        w: parseInt(trigger.dataset.featureMediaWidth, 10)
      };
    });
  }

  function initLightbox(carousel) {
    var triggers = carousel.querySelectorAll('[data-feature-lightbox-trigger]');

    if (!triggers.length || !window.PhotoSwipe || !window.PhotoSwipeUI_Default) {
      return null;
    }

    function openLightbox(event) {
      var trigger = event.target.closest('[data-feature-lightbox-trigger]');

      if (!trigger || !carousel.contains(trigger) || carousel.classList.contains('is-dragging')) {
        return;
      }

      var items = createLightboxItems(carousel);
      var index = Array.prototype.indexOf.call(triggers, trigger);
      var pswpElement = document.querySelector('.pswp');

      if (!pswpElement || index < 0) {
        return;
      }

      var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
        allowPanToNext: false,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        index: index,
        pinchToClose: false,
        preloaderEl: false,
        shareEl: false,
        tapToToggleControls: false
      });

      items.forEach(function(item) {
        if (!item.html) {
          return;
        }

        item.html.addEventListener('click', function(itemEvent) {
          if (itemEvent.target === item.html) {
            gallery.close();
          }
        });
      });

      gallery.listen('beforeChange', pauseLightboxVideos);
      gallery.listen('close', pauseLightboxVideos);
      gallery.listen('afterChange', function() {
        var currentItem = gallery.currItem;
        var video = currentItem && currentItem.html
          ? currentItem.html.querySelector('.product-features-lightbox__video')
          : null;

        if (video) {
          video.play().catch(function() {});
        }
      });
      gallery.init();

      var activeVideo = gallery.currItem && gallery.currItem.html
        ? gallery.currItem.html.querySelector('.product-features-lightbox__video')
        : null;
      if (activeVideo) {
        activeVideo.play().catch(function() {});
      }
    }

    carousel.addEventListener('click', openLightbox);
    return function() {
      carousel.removeEventListener('click', openLightbox);
    };
  }

  function initSection(container) {
    if (!container || instances.has(container)) {
      return;
    }

    var carousel = container.querySelector('[data-product-features-carousel]');
    var slides = carousel ? carousel.querySelectorAll('[data-feature-slide]') : [];

    if (!carousel || !slides.length) {
      return;
    }

    var destroyLightbox = initLightbox(carousel);

    if (slides.length === 1 || !window.theme || !theme.Slideshow) {
      carousel.classList.add('is-single-feature');
      instances.set(container, {destroyLightbox: destroyLightbox});
      return;
    }

    var slideshow = new theme.Slideshow(carousel, {
      adaptiveHeight: false,
      avoidReflow: true,
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      pageDots: true,
      prevNextButtons: true,
      wrapAround: false,
      callbacks: {
        onChange: function(index) {
          pauseInactiveVideos(carousel, index);
        }
      }
    });
    var firstMedia = carousel.querySelector('.product-features__media');
    var resizeObserver = null;

    slideshow.slideshow.on('dragStart', function() {
      carousel.classList.add('is-dragging');
    });

    slideshow.slideshow.on('dragEnd', function() {
      window.setTimeout(function() {
        carousel.classList.remove('is-dragging');
      }, 0);
    });

    updateArrowPosition(carousel);

    if (firstMedia && window.ResizeObserver) {
      resizeObserver = new ResizeObserver(function() {
        updateArrowPosition(carousel);
      });
      resizeObserver.observe(firstMedia);
    }

    carousel.querySelectorAll('img, video').forEach(function(media) {
      var eventName = media.tagName === 'VIDEO' ? 'loadedmetadata' : 'load';
      media.addEventListener(eventName, function() {
        slideshow.reposition();
        updateArrowPosition(carousel);
      }, {once: true});
    });

    instances.set(container, {
      destroyLightbox: destroyLightbox,
      resizeObserver: resizeObserver,
      slideshow: slideshow
    });
  }

  function initFeatures(scope) {
    if (scope.matches && scope.matches('[data-product-features]')) {
      initSection(scope);
    }

    scope.querySelectorAll('[data-product-features]').forEach(initSection);
  }

  function unloadSection(container) {
    var section = container.matches && container.matches('[data-product-features]')
      ? container
      : container.querySelector('[data-product-features]');
    var instance = section ? instances.get(section) : null;

    if (instance && instance.resizeObserver) {
      instance.resizeObserver.disconnect();
    }

    if (instance && instance.destroyLightbox) {
      instance.destroyLightbox();
    }

    if (instance && instance.slideshow && typeof instance.slideshow.destroy === 'function') {
      instance.slideshow.destroy();
    }

    instances.delete(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFeatures(document);
    });
  } else {
    initFeatures(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initFeatures(event.target);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    unloadSection(event.target);
  });
})();
